// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__PF4Vr","dark":"Toggle_dark__pmlKH","slider":"Toggle_slider__lFWBJ","toggleInput":"Toggle_toggleInput__XQpUu"};